/**
 * 千宏协议同意弹窗
 */
import './index.scss';
import { Toast } from '@hb/coffee';
import { Component, Vue } from 'vue-property-decorator';
import { AgreementPo } from '@/po/agreement';
import { CommodityPo } from '@/po/commodity';
import router from '@/router';
// import PopupSlide from '@/components/popup-slide';
import { RouterV2Enum } from '@/router/router-names';
import { AgreementTypeEnum } from '@/enums/agreement-type';
import { changeTabbarShowStatus, skNativeContainer } from '@/api/native/container';
import isShowContainerPath from '@/shared/utils/isShowContainerPath';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import { getPresentationConfig } from '@/shared/verify-credit-controller';

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const PopupSlide = () => import(
  /* webpackChunkName: "popup-slide" */'@/components/popup-slide'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;

@Component
class AuthDialog extends Vue {
  private show = false;

  private agree = true;

  // 同意协议之后的回调
  private resolve: PromiseResolve<void> | null = null;

  private reject: PromiseReject | null = null;

  private contracts: AgreementPo[] = [];

  private product: CommodityPo.Info | null = null;

  /**
   * 部分协议更新场景：非全部 isAgreed = true && isAgreed == false
  */
  private get someProtocolUpdates() {
    const agreedProtocol = this.contracts.filter((item) => item.isAgreed === true);
    const unAgreeProtocol = this.contracts.filter((item) => item.isAgreed === false);

    return agreedProtocol.length && unAgreeProtocol.length;
  }

  /**
   * 根据合同协议是否更新显示title
  */
  private get popTitle() {
    return this.someProtocolUpdates ? '协议更新提醒' : '服务授权申请';
  }

  private hideSlide(unShowTabbar?:boolean) {
    this.show = false;
    /** 关闭页面弹窗，同步到弹窗管理 */
    dialogHelper.closeDialogNotify();

    /** 解决路由跳转，不要显示tabbar的场景 */
    if (!unShowTabbar) {
      /** 待popup完全消失后，显示tabbar */
      changeTabbarShowStatus(true, {
        delay: 300,
        shouldShowCallback: () => isShowContainerPath(this.$route.path),
      });
    }
  }

  public open(
    contracts: AgreementPo[],
    product?: CommodityPo.Info,
  ): Promise<void> {
    this.contracts = contracts;
    this.show = true;
    this.agree = true;
    this.product = product || this.product;
    /** 隐藏tabbar */
    changeTabbarShowStatus(false);
    /** 页面已展示弹窗，同步状态到弹窗管理 */
    dialogHelper.applyOpenDialog(true);

    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  private close() {
    this.hideSlide();

    if (this.reject) {
      this.reject();
    }
  }

  private onAgree() {
    if (!this.agree) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast('请同意服务协议');
    } else {
      this.hideSlide();

      if (this.resolve) {
        this.resolve();
      }
    }
  }

  /**
   * 跳转协议列表页（打开新的页面，保证弹窗留存）
   */
  private goContractList() {
    this.hideSlide(true);

    this.$router.push({
      path: RouterV2Enum.legalConstract,
      query: { contractType: String(AgreementTypeEnum.SERVE) },
    });
  }

  protected render() {
    return (
      <PopupSlide
        v-model={this.show}
        class={[this.show && 'AuthDialog', getPresentationConfig().theme]}
        popPostion="left"
        confirmText="我已阅读并同意"
        popTitle={this.popTitle}
        onConfirm={this.onAgree.bind(this)}
        onClose={this.close.bind(this)}
        closeOnClickOverlay={false}
      >
        {this.someProtocolUpdates ? (
          <div slot="popupContent" class="agreementContent">
            <p class="getInfoTips" onClick={this.goContractList.bind(this)}>为了更好地提供服务，我们已更新部分协议内容。<br /><span>《用户协议及隐私政策》</span></p>
          </div>
        ) : (
          <div slot="popupContent" class="agreementContent">
            <p class="getInfoTips">获取您的个人基础信息为您服务</p>
            <p onClick={this.goContractList.bind(this)}>
              我已同意<span>《用户协议及隐私政策》</span>
            </p>
          </div>
        )}
      </PopupSlide>
    );
  }
}

let instance: AuthDialog;

export const authDialog = {
  open(
    contracts: AgreementPo[],
    product?: CommodityPo.Info,
  ): Promise<void> {
    if (!instance) {
      instance = new AuthDialog({
        router,
      }).$mount();
      document.body.appendChild(instance.$el);
    }
    return instance.open(contracts, product);
  },
};
